import { render } from "./ReviewStatus.vue?vue&type=template&id=484d37fc&scoped=true"
import script from "./ReviewStatus.vue?vue&type=script&lang=js"
export * from "./ReviewStatus.vue?vue&type=script&lang=js"

import "./ReviewStatus.vue?vue&type=style&index=0&id=484d37fc&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484d37fc"]])

export default __exports__